import React from 'react';
import { Header } from "semantic-ui-react";

const ManageCategoriesHeader = () => {
    return (
        <Header
            as="h3"
            style={{ textAlign: "left", display: "inlineBlock" }}
        >
            Manage Categories
        </Header>
    )
}

export default ManageCategoriesHeader